var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-field",
        {
          staticClass: "mt-5",
          attrs: {
            label: _vm.$t("common.parentCategory"),
            type: _vm.checkEmpty(_vm.errors.parentCategorySlug)
              ? ""
              : "is-danger",
            message: _vm.checkEmpty(_vm.errors.parentCategorySlug)
              ? ""
              : _vm.errors.parentCategorySlug[0],
          },
        },
        [
          _c("category-select", {
            model: {
              value: _vm.parentCategorySlug,
              callback: function ($$v) {
                _vm.parentCategorySlug = $$v
              },
              expression: "parentCategorySlug",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-5",
          attrs: {
            label: _vm.$t("form.slug"),
            type: _vm.checkEmpty(_vm.errors.slug) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.slug) ? "" : _vm.errors.slug[0],
          },
        },
        [
          _vm.isEdit
            ? _c("div", [
                _vm._v("\n      " + _vm._s(_vm.category.slug) + "\n    "),
              ])
            : _c("b-input", {
                on: {
                  blur: function ($event) {
                    return _vm.validate("slug")
                  },
                },
                model: {
                  value: _vm.slug,
                  callback: function ($$v) {
                    _vm.slug = $$v
                  },
                  expression: "slug",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          staticClass: "mt-5",
          attrs: {
            label: _vm.$t("form.label"),
            type: _vm.checkEmpty(_vm.errors.label) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.label)
              ? ""
              : _vm.errors.label[0],
          },
        },
        [
          _c("b-input", {
            on: {
              blur: function ($event) {
                return _vm.validate("label")
              },
            },
            model: {
              value: _vm.label,
              callback: function ($$v) {
                _vm.label = $$v
              },
              expression: "label",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "field mt-5" }, [
        _c("div", { staticClass: "control" }, [
          _c("button", {
            staticClass: "button is-info",
            attrs: { disabled: _vm.isLoading || _vm.hasErrors },
            domProps: {
              textContent: _vm._s(
                _vm.isEdit ? _vm.$t("common.edit") : _vm.$t("common.add")
              ),
            },
            on: {
              click: function ($event) {
                return _vm.save(true)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control" }, [
          _c("button", {
            staticClass: "button is-light",
            attrs: { disabled: _vm.isLoading },
            domProps: { textContent: _vm._s(_vm.$t("common.cancel")) },
            on: { click: _vm.cancel },
          }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }